


















































































import Vue from "vue";

import PropertySelector, {
  FlexProperty
} from "@/components/PropertySelector.vue";

import Box from "@/components/Box.vue";

import * as FlexboxProperties from "@/models/flexbox-properties";

export default Vue.extend({
  name: "App",
  components: { PropertySelector, Box },
  data: () => ({
    appName: "Flexbox Illustrated",
    FlexboxProperties,
    actualProperties: {
      "flex-direction": FlexboxProperties.FlexDirectionValues.ROW,
      "flex-wrap": FlexboxProperties.FlexWrapValues.NOWRAP,
      "justify-content": FlexboxProperties.JustifyContentValues.FLEX_START,
      "align-items": FlexboxProperties.AlignItemsValues.STRETCH,
      "align-content": FlexboxProperties.AlignContentValues.STRETCH
    } as any,
    actualPropertiesChildren: {
      "align-self": FlexboxProperties.AlignSelfValues.AUTO
    } as any,
    maxBox: 5,
    flexGrow: Array(5).fill(0) as number[],
    flexShrink: Array(5).fill(0) as number[]
  }),
  computed: {
    flexProperties(): FlexProperty[] {
      return Object.entries({ ...FlexboxProperties }).map(([k, v]) => {
        const sanitizedWords = k.replace(/Values/g, "").split(/(?=[A-Z])/);
        return {
          name: sanitizedWords
            .map((x, i) => (i !== 0 ? x.toLocaleLowerCase() : x))
            .join(" "),
          id: sanitizedWords.join("-").toLocaleLowerCase(),
          appliedToChildren: ["align-self"].includes(
            sanitizedWords.join("-").toLocaleLowerCase()
          ),
          values: Object.values(v).map(x => x.toString())
        } as FlexProperty;
      });
    }
  },
  methods: {
    onPropertyChanged(data: FlexProperty & { value: string }): void {
      if (data.appliedToChildren) {
        this.actualPropertiesChildren[data.id] = data.value;
      } else {
        this.actualProperties[data.id] = data.value;
      }
    },
    updateFlexWidth(i: number, value: number, prop: "grow" | "shrink"): void {
      if (prop === "grow") {
        this.flexGrow[i - 1] = Number(value);
      } else {
        this.flexShrink[i - 1] = Number(value);
      }
      this.$forceUpdate();
    }
  }
});
